"use client";
import React from "react";
import { OrderGuard } from "services/orders";

export default function Layout({ children }: { children: React.ReactNode }) {
  return <OrderGuard>{children}</OrderGuard>;
}
